import { render, staticRenderFns } from "./EmrVitalsignList.vue?vue&type=template&id=010d20bd&scoped=true"
import script from "./EmrVitalsignList.vue?vue&type=script&lang=js"
export * from "./EmrVitalsignList.vue?vue&type=script&lang=js"
import style0 from "./EmrVitalsignList.vue?vue&type=style&index=0&id=010d20bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010d20bd",
  null
  
)

export default component.exports